//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { xiaoIStore,getSession} from '../../service/service';
  import {constant} from '../../common/publicConstant';
  export default {
    name:"index",
    data(){
      return {
        imgMaxSize:false,  //是否大尺寸图片
        billShow:true,  //是否显示运单框
        phoneShow:false,  //是否显示电话框
        swiperIndex: 1,  //默认收件人
        swiperSlect: 'yundan',
        siteCode: '999999',
        router: '',
        vipCode: '',//海外客户编码
        parameters: {
          waybillNo:'',
          mobile: ''
        },
        //图片链接
        imgs:{
          dreceiver:require('../../../static/img/dreceiver@2x.png'),
          receiver:require('../../../static/img/receiver@2x.png'),
          dsender:require('../../../static/img/dsender@2x.png'),
          sender:require('../../../static/img/sender@2x.png'),
          dother:require('../../../static/img/dother@2x.png'),
          other:require('../../../static/img/other@2x.png'),
        },
        flag: false,
        platform: '',
        openid:'',
        isFirstStep: true,
        source: '',
        showDialog: false,
      }
    },
    created:function() {
      this.autoSize();  //自适应大小
      if (this.getUrlParams("flag") !== 'null'){
        let flag =  this.getUrlParams("flag");
        if (flag === 'true'){
          this.flag = true;
        }else {
          this.flag = false;
        }
      }
      this.platform = this.getUrlParams("platform");
      if(this.getUrlParams("waybillNo") !== null && this.getUrlParams("waybillNo") !== "null"  && this.getUrlParams("waybillNo") !== "")
      {
        this.parameters.waybillNo=this.getUrlParams("waybillNo");
      }
      if(this.getUrlParams("nodeCode") !== null && this.getUrlParams("nodeCode") !== "null"  && this.getUrlParams("nodeCode") !== "")
      {
        this.siteCode = this.getUrlParams("nodeCode");
      }
      let source = this.getUrlParams("source");
      if(source !== null && source !== "null"  && source !== "" && source !== 'undefined' && source !== undefined)
      {
        this.source = source;
      }
      if (this.getUrlParams("openid") !== null){
        this.openid = this.getUrlParams("openid");
        window.localStorage.setItem("openid", this.getUrlParams("openid"));  //openid
      } else {
        let openId = window.localStorage.getItem("openid");
        if  (openId !== 'null' && openId !== 'undefined' && openId !== '' && openId !== null && openId !== undefined) {
          this.openid = openId;
        }else{
          this.getOpenId();
        }
      }
      window.localStorage.setItem("flag", this.flag);  //是否小I已服务
      window.localStorage.setItem("platform", this.platform);  //平台
      window.localStorage.setItem("openid", this.openid);  //客户标志
      window.localStorage.setItem("source", this.source);  //数据来源
      if (this.openid !== 'null'  && this.openid  !== null  && this.openid !== 'undefined'){
          //this.getSession();  //这里校验客户是否存在
      }

    },
    methods:{
      //屏幕自适应大小
      autoSize:function(){
        var width= window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if(width>320)
        {
           this.imgMaxSize=true;
        }
      },
       //客户类型选项卡
      imgClick:function (type) {
        this.swiperIndex=type;
        window.localStorage.setItem("customerType", this.swiperIndex);  //客户类型
        console.log(this.swiperIndex)
      },
      
      //运单号或电话选中
      tabClick:function (e,type) {
        this.swiperSlect=type;
        if(type==="yundan")
        {
          this.billShow=true;
          this.phoneShow=false;
        }else{
          this.billShow=false;
          this.phoneShow=true;
        }
      },
      //本地创建openid
      getOpenId(){
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
        s[8] = s[13] = s[18] = s[23] = "-";

        var uuid = s.join("");
        this.openid = uuid;
      },
      getUrlParams(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        let url = location.search; // 获取url中"?"符后的字串
        let str = url.substr(1).match(reg);
        if (str != null) {
          return unescape(str[2]);
        }
        return null;
      },
      //异步会话状态
      async getSession (){
        let data = {};
        data.platform = this.platform;
        data.openid = this.openid;
        let res = await getSession(data);
        if (res.status === 0){
          if(res.data.stage!=="auto"  && res.data.stage !=="offline")
          {
            this.$router.push({
              name: "chat"
            });
          }
        }
      },
      //进入聊天会话
      async goToChat() {
        if(this.swiperSlect==='yundan')
        {
          if (this.parameters.waybillNo === '') {
            let timerFlag = this.warnTimeOut(3000);
            this.warnPart('操作提示', '请填写<label style="color: #EDAA35">运单号</label>哦', timerFlag);
            return;
          }
        }else{
          if (this.parameters.mobile === '') {
            let timerFlag = this.warnTimeOut(3000);
            this.warnPart('操作提示', '请填写<label style="color: #EDAA35">手机号</label>哦', timerFlag);
            return;
          }
        }

        if (this.parameters.waybillNo !== ''){
          var reg = constant.waybillNoRegular();
          if (!reg.test(this.parameters.waybillNo)) {
            let timerFlag = this.warnTimeOut(3000);
            this.warnPart('操作提示', '<label style="color: #EDAA35">运单号</label>不正确，请重新填写', timerFlag);
            return;
          }
          this.router = '单号分流-无信息';
          if (this.source !== null && this.source !== "null"  && this.source !== "" && this.source !== 'undefined' && this.source !== undefined){
            this.siteCode = "999995";
            this.router =  "蛟龙购单号";
          }else {
            //运单号分流
            let result = await xiaoIStore(this.parameters.waybillNo);
            if (result.status === 0){
              this.siteCode = result.data.storeCode;
              this.router =  result.data.router;
              this.vipCode = result.data.vipCode;
            }
          }
          this.cacheParams();
          this.$router.push({
            name: "chat2"
          });
        }
        if (this.parameters.mobile !== ''){
          var mobileReg = constant.mobileRegular();
          if (!mobileReg.test(this.parameters.mobile)) {
            let timerFlag = this.warnTimeOut(3000);
            this.warnPart('操作提示', '<label style="color: #EDAA35">手机号</label>格式不正确，请重新填写', timerFlag);
            return;
          }
          this.router = '电话分流';
          this.siteCode = '999999';
          this.cacheParams();
          this.$router.push({
            name: "chat"
          });
        }
      },
      //无单咨询进入在线
      noSingleToChat(){
        //无单咨询判断客户身份类型
        if(this.swiperIndex<1)
        {
          let timerFlag = this.warnTimeOut(3000);
          this.warnPart('操作提示', '咨询前，需要选择您的<label style="color: #EDAA35">咨询角色</label>哦', timerFlag);
          return;
        }
        this.parameters.waybillNo = '';
        this.router = '无单咨询分流';
        this.cacheParams();
        console.log("客户类型："+this.swiperIndex);
        this.$router.push({
          name: "chat"
        });
      },
      //缓存数据
      cacheParams(){
        window.localStorage.setItem("siteCode",this.siteCode);  //网点编码
        window.localStorage.setItem("mobile", this.parameters.mobile);  //手机号
        window.localStorage.setItem("router", this.router);  //路由
        window.localStorage.setItem("waybillNo", this.parameters.waybillNo);  //运单号
        window.localStorage.setItem("vipCode", this.vipCode);  //海外客户编码
        window.localStorage.setItem("customerType", this.swiperIndex);  //客户类型
      },
      // 提示框
      warnPart(title, content, timerFlag) {
        this.$vux.alert.show({
          title: title,
          content: content,
          buttonText:"知道了",
          maskZIndex: 100,
          onHide() {
            window.clearTimeout(timerFlag);
          }
        });
      },
      // 错误提示定时器
      warnTimeOut(times) {
        let timerFlag = window.setTimeout(() => {
          this.$vux.alert.hide();
        }, times);
        return timerFlag;
      },
    }
  }



// WEBPACK FOOTER //
// ./src/views/index/index.vue